import type { BlockExportMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { BlogBlock1 } from "./BlogBlock1";

export const blogBlocks: BlockExportMapping = {
  BlogBlock1,
};
